(function () {
  'use strict';

  /* -------------------------------------------------------
     Estado global del configurador.
     update() es el único punto de escritura.
  ------------------------------------------------------- */
  const state = {
    tipo:                null,
    tipo_chocolate:      null,
    tamaño:              null,
    envase:              null,
    personalizacion:     null,
    cosecha:             null,
    variedad:            null,
    cantidad:            null,
    extras:              [],
    texto_personalizado: '',
    archivo:             null,
  };

  /* Orden canónico de los campos (de más general a más específico).
     limpiarDesde() lo usa para generar resets en cascada. */
  const ORDEN_CAMPOS = [
    'tipo', 'tipo_chocolate', 'tamaño', 'envase', 'personalizacion', 'cosecha',
    'variedad', 'cantidad', 'extras', 'texto_personalizado', 'archivo',
  ];

  const NOMBRES_PERS = {
    serigrafia:   'Serigrafía',
    etiqueta:     'Etiqueta',
    color:        'Color',
    transparente: 'Transparente',
  };

  /* Mapeo de id de cosecha al sufijo usado en catalogo.precios.
     'temprana_octubre' aparece como 'temprana' en las claves. */
  const COSECHA_PRECIO_KEY = {
    septiembre:       'septiembre',
    temprana_octubre: 'temprana',
    oro_liquido:      'oro_liquido',
  };

  let catalogo        = null;
  let root            = null; // apunta al contenedor activo durante render (se redirige temporalmente)
  let rootEl          = null; // siempre apunta al div#vi-configurador-root real
  let resumenParcialEl = null; // panel de resumen persistente bajo el configurador
  let pasoActual = 'tipo';
  let dirNav     = 1;    // 1 = adelante, -1 = atrás (para la animación)

  /* -------------------------------------------------------
     Helpers de precio.
  ------------------------------------------------------- */

  /* Determina la clave de catalogo.tramos_cantidad según
     la combinación actual de tamaño, envase y personalización. */
  function getTramoClave() {
    var tam  = state.tamaño;
    var id   = state.envase;
    var pers = state.personalizacion;
    if (id === 'baby_ibero')                return 'baby_ibero';
    if (tam === '100ml' || tam === '200ml') return 'botella_pequena';
    if (tam === '250ml')                    return 'al_andalus_250ml';
    if ((id === 'seed_500ml' || id === 'exclusive_500ml') && pers === 'etiqueta') {
      return 'etiqueta_seed_exclusive';
    }
    return pers === 'serigrafia' ? 'botella_500ml_serigrafia' : 'botella_500ml_etiqueta';
  }

  /* Mínimo de unidades para la combinación envase + personalización. */
  function getMinimo() {
    var clave = state.envase + '_' + state.personalizacion;
    return catalogo.minimos_personalizacion[clave]
        || catalogo.minimos_personalizacion['_default'];
  }

  /* Precio unitario (€) para un valor de tramo exacto, o null si no existe.
     Siempre recibe el tramo aplicable, nunca una cantidad libre. */
  function getPrecioUnitario(tramoValor) {
    var clave = state.envase === 'baby_ibero'
      ? 'baby_ibero_' + state.personalizacion
      : state.envase + '_' + state.personalizacion + '_' + COSECHA_PRECIO_KEY[state.cosecha];
    var tabla = catalogo.precios[clave];
    if (!tabla) return null;
    var v = tabla[String(tramoValor)];
    return v !== undefined ? v : null;
  }

  /* Devuelve el tramo más alto que sea ≤ cantidad (precio más favorable).
     Null si la cantidad está por debajo del primer tramo. */
  function getTramoAplicable(cantidad, tramos) {
    var aplicable = null;
    for (var i = 0; i < tramos.length; i++) {
      if (tramos[i] <= cantidad) aplicable = tramos[i];
      else break;
    }
    return aplicable;
  }

  /* Calcula todos los totales del pedido actual. Requiere state.cantidad. */
  function calcularTotales() {
    var tramoClave = getTramoClave();
    var tramos = catalogo.tramos_cantidad[tramoClave]
      .filter(function (t) { return t >= getMinimo(); });
    var tramo = getTramoAplicable(state.cantidad, tramos);
    var precioUnit = getPrecioUnitario(tramo);
    var subtotalAceite = precioUnit * state.cantidad;
    var extraLibrito = 0;
    var extraSerigrafia = 0;
    if (state.extras.indexOf('librito_cuello') !== -1) {
      extraLibrito = catalogo.extras.librito_cuello.precio * state.cantidad;
    }
    if (state.extras.indexOf('serigrafia_color') !== -1) {
      extraSerigrafia = catalogo.extras.serigrafia_color.precio;
    }
    return {
      precioUnit: precioUnit,
      tramo: tramo,
      subtotalAceite: subtotalAceite,
      extraLibrito: extraLibrito,
      extraSerigrafia: extraSerigrafia,
      total: subtotalAceite + extraLibrito + extraSerigrafia,
    };
  }

  /* -------------------------------------------------------
     Genera un objeto con todos los campos desde 'campo'
     en adelante puestos a su valor vacío.
     Centraliza el reset en cascada: ningún handler lo repite.
  ------------------------------------------------------- */
  function limpiarDesde(campo) {
    const idx = ORDEN_CAMPOS.indexOf(campo);
    const cambios = {};
    ORDEN_CAMPOS.slice(idx).forEach(function (k) {
      if      (k === 'extras')               cambios[k] = [];
      else if (k === 'texto_personalizado')  cambios[k] = '';
      else                                   cambios[k] = null;
    });
    return cambios;
  }

  /* -------------------------------------------------------
     Muta el estado y vuelve a renderizar.
  ------------------------------------------------------- */
  function update(cambios, avanzar) {
    Object.assign(state, cambios);
    if (avanzar) {
      dirNav = 1;
      var pasos = getPasos();
      var idx   = pasos.findIndex(function (p) { return p.id === pasoActual; });
      if (idx !== -1 && idx < pasos.length - 1) pasoActual = pasos[idx + 1].id;
    }
    render();
  }

  /* -------------------------------------------------------
     Helpers de construcción de DOM.
  ------------------------------------------------------- */

  /* Crea un elemento con clase y texto opcionales. */
  function el(tag, className, texto) {
    var nodo = document.createElement(tag);
    if (className)          nodo.className   = className;
    if (texto !== undefined) nodo.textContent = texto;
    return nodo;
  }

  /* Crea un <button> de opción seleccionable. */
  function crearBotonOpcion(action, value, seleccionado) {
    var btn = document.createElement('button');
    btn.type           = 'button';
    btn.className      = seleccionado ? 'vi-opcion vi-opcion--selected' : 'vi-opcion';
    btn.dataset.action = action;
    btn.dataset.value  = value;
    btn.setAttribute('aria-pressed', seleccionado ? 'true' : 'false');
    return btn;
  }

  /* Formatea un array de ids de personalización como texto legible.
     ['serigrafia']              → 'Serigrafía'
     ['serigrafia', 'etiqueta'] → 'Serigrafía y Etiqueta'  */
  function formatPersonalizaciones(lista) {
    var nombres = lista.map(function (p) { return NOMBRES_PERS[p] || p; });
    if (nombres.length <= 1) return nombres[0] || '—';
    return nombres.slice(0, -1).join(', ') + ' y ' + nombres[nombres.length - 1];
  }

  /* -------------------------------------------------------
     Lista dinámica de pasos visibles según el state actual.
     Los pasos condicionales (personalizacion, variedad) solo
     aparecen cuando corresponde.
  ------------------------------------------------------- */
  function getPasos() {
    var pasos = [
      { id: 'tipo', fn: renderPaso0 },
    ];

    if (state.tipo === 'aceite') {
      pasos.push(
        { id: 'tamaño', fn: renderPaso1 },
        { id: 'envase', fn: renderPaso2 }
      );
      if (state.envase) {
        var pers = catalogo.envases[state.envase].personalizaciones;
        if (pers.length > 1) {
          (function (p) {
            pasos.push({ id: 'personalizacion', fn: function () { renderPaso3(p); } });
          })(pers);
        }
      }
      if (state.envase === 'baby_ibero') {
        if (state.personalizacion === 'color') {
          pasos.push({ id: 'variedad', fn: renderPasoBabyVariante });
        }
      } else {
        pasos.push({ id: 'cosecha', fn: renderPaso4 });
        if (state.cosecha === 'temprana_octubre') {
          pasos.push({ id: 'variedad', fn: renderPaso5 });
        }
      }
      pasos.push(
        { id: 'cantidad', fn: renderPaso6 },
        { id: 'extras',   fn: renderPaso7 }
      );
      if (
        state.extras.indexOf('librito_cuello') !== -1 ||
        state.personalizacion === 'serigrafia' ||
        state.personalizacion === 'etiqueta'
      ) {
        pasos.push({ id: 'texto', fn: renderPaso8 });
      }
      pasos.push({ id: 'resumen', fn: renderPaso9 });
    } else if (state.tipo === 'chocolate') {
      pasos.push(
        { id: 'tipo_chocolate', fn: renderPasoChocolateTipo },
        { id: 'cantidad',       fn: renderPasoCantidadChocolate },
        { id: 'resumen',        fn: renderPaso9 }
      );
    }

    return pasos;
  }

  /* true si el paso tiene selección válida → habilita el botón →. */
  function pasoCompleto(pasoId) {
    switch (pasoId) {
      case 'tipo':            return state.tipo !== null;
      case 'tipo_chocolate':  return state.tipo_chocolate !== null;
      case 'tamaño':          return state.tamaño !== null;
      case 'envase':          return state.envase !== null;
      case 'personalizacion': return state.personalizacion !== null;
      case 'cosecha':         return state.cosecha !== null;
      case 'variedad':        return state.variedad !== null;
      case 'cantidad':        return state.cantidad !== null;
      default:                return true;
    }
  }

  /* -------------------------------------------------------
     Render: muestra un único paso a la vez (slider).
     root se redirige temporalmente al stepDiv para que
     cada renderPasoN() siga usando root.appendChild sin cambios.
  ------------------------------------------------------- */
  function render() {
    var pasos = getPasos();

    /* Si pasoActual desapareció (p.ej. variedad al cambiar cosecha),
       ir al último paso válido de la nueva lista. */
    var idx = pasos.findIndex(function (p) { return p.id === pasoActual; });
    if (idx === -1) {
      idx = pasos.length - 1;
      pasoActual = pasos[idx].id;
    }

    rootEl.innerHTML = '';
    rootEl.appendChild(renderBarraNavegacion(pasos, idx));

    var stepDiv = document.createElement('div');
    stepDiv.className = dirNav >= 0 ? 'vi-slider__step' : 'vi-slider__step vi-slider__step--atras';
    root = stepDiv;
    pasos[idx].fn();
    root = rootEl;
    rootEl.appendChild(stepDiv);

    var section = rootEl.closest('section') || rootEl;
    var top = section.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });

    renderResumenParcial();
  }

  /* Barra superior: ← · puntos · contador · → */
  function renderBarraNavegacion(pasos, idx) {
    var barra = el('div', 'vi-nav');

    var atras = document.createElement('button');
    atras.type           = 'button';
    atras.className      = 'vi-nav__btn vi-nav__btn--atras';
    atras.dataset.action = 'nav-atras';
    atras.setAttribute('aria-label', 'Paso anterior');
    atras.textContent    = '←';
    atras.disabled       = (idx === 0);

    var dots = el('div', 'vi-progreso__dots');
    pasos.forEach(function (_, i) {
      dots.appendChild(el('span',
        i < idx    ? 'vi-progreso__dot vi-progreso__dot--hecho'
        : i === idx ? 'vi-progreso__dot vi-progreso__dot--actual'
        :              'vi-progreso__dot'
      ));
    });

    var texto = el('span', 'vi-progreso__texto', (idx + 1) + ' / ' + pasos.length);

    var centro = el('div', 'vi-nav__centro');
    centro.appendChild(dots);
    centro.appendChild(texto);

    var adelante = document.createElement('button');
    adelante.type           = 'button';
    adelante.className      = 'vi-nav__btn vi-nav__btn--adelante';
    adelante.dataset.action = 'nav-adelante';
    adelante.setAttribute('aria-label', 'Siguiente paso');
    adelante.textContent    = '→';
    adelante.disabled       = (idx >= pasos.length - 1 || !pasoCompleto(pasos[idx].id));

    barra.appendChild(atras);
    barra.appendChild(centro);
    barra.appendChild(adelante);
    return barra;
  }

  /* -------------------------------------------------------
     Paso 0 — Selección de tipo de producto: aceite o chocolate.
  ------------------------------------------------------- */
  function renderPaso0() {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '¿Qué producto quieres personalizar?'));

    var opciones = el('div', 'vi-opciones vi-opciones--tipo');

    var imgs = {
      aceite:    rootEl.dataset.imgAceite    || '',
      chocolate: rootEl.dataset.imgChocolate || '',
      nueva:     rootEl.dataset.imgNueva     || '',
    };

    var tipos = [
      { id: 'aceite',    nombre: 'Aceite de oliva', sub: 'Virgen extra',   img: imgs.nueva },
      { id: 'chocolate', nombre: 'Chocolate',        sub: 'Tableta artesana',  img: imgs.chocolate },
    ];

    tipos.forEach(function (t) {
    var btn     = crearBotonOpcion('select-tipo', t.id, state.tipo === t.id);
    var imgSlot = el('div', 'vi-opcion__img');
    if (t.img) {
      var img = document.createElement('img');
      img.src = t.img;
      img.alt = t.nombre;
      imgSlot.appendChild(img);
    }
    btn.appendChild(imgSlot);
    btn.appendChild(el('span', 'vi-opcion__nombre', t.nombre));
    btn.appendChild(el('span', 'vi-opcion__sub', t.sub));
    opciones.appendChild(btn);
  });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 1 — Selección de tamaño de botella.
     Tamaños únicos de VI_CATALOGO.envases, ordenados por ml.
  ------------------------------------------------------- */
  function renderPaso1() {
    var tamanos = Array.from(
      new Set(Object.values(catalogo.envases).map(function (e) { return e.tamaño; }))
    ).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });

    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '1. Elige el tamaño de tu botella'));

    var opciones = el('div', 'vi-opciones');
    tamanos.forEach(function (tam) {
      var nModelos = Object.values(catalogo.envases)
        .filter(function (e) { return e.tamaño === tam; }).length;

      var btn = crearBotonOpcion('select-size', tam, state.tamaño === tam);
      btn.appendChild(el('span', 'vi-opcion__tamaño', tam));
      btn.appendChild(el('span', 'vi-opcion__sub', nModelos + (nModelos === 1 ? ' modelo' : ' modelos')));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 2 — Selección de modelo de envase.
     Solo se renderiza si state.tamaño existe.
     Filtra VI_CATALOGO.envases por el tamaño elegido.
  ------------------------------------------------------- */
  function renderPaso2() {
    var entradas = Object.entries(catalogo.envases)
      .filter(function (par) { return par[1].tamaño === state.tamaño; });

    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '2. Elige el modelo de botella'));

    var opciones = el('div', 'vi-opciones');
    entradas.forEach(function (par) {
      var id     = par[0];
      var envase = par[1];

      var btn     = crearBotonOpcion('select-envase', id, state.envase === id);
      var imgSlot = el('div', 'vi-opcion__img');
      var imgKey  = 'imgEnvase' + id.split('_').map(function (p) {
        return p.charAt(0).toUpperCase() + p.slice(1);
      }).join('');
      var imgUrl  = rootEl.dataset[imgKey];
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = envase.nombre;
        imgSlot.appendChild(img);
      }
      btn.appendChild(imgSlot);
      btn.appendChild(el('span', 'vi-opcion__nombre', envase.nombre));
      btn.appendChild(el('span', 'vi-opcion__personalizaciones',
        formatPersonalizaciones(envase.personalizaciones)));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 3 — Tipo de personalización.
     Solo se renderiza si el envase tiene más de una opción.
     Recibe el array ya filtrado para no releerlo.
  ------------------------------------------------------- */
  function renderPaso3(pers) {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '3. Tipo de personalización'));

    var opciones = el('div', 'vi-opciones');
    var envaseKey = state.envase.split('_').map(function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }).join('');

    pers.forEach(function (p) {
      var btn = crearBotonOpcion('select-personalizacion', p, state.personalizacion === p);

      var imgUrl;
      if (state.envase === 'baby_ibero') {
        imgUrl = rootEl.dataset['imgBaby' + p.charAt(0).toUpperCase() + p.slice(1)];
      } else {
        imgUrl = rootEl.dataset['imgPers' + envaseKey + p.charAt(0).toUpperCase() + p.slice(1)];
      }
      if (imgUrl) {
        var imgSlot = el('div', 'vi-opcion__img');
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = NOMBRES_PERS[p] || p;
        imgSlot.appendChild(img);
        btn.appendChild(imgSlot);
      }

      btn.appendChild(el('span', 'vi-opcion__nombre', NOMBRES_PERS[p] || p));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Baby Ibero — selección de color de botella.
     Solo aparece cuando personalizacion === 'color'.
     Reutiliza state.variedad para guardar el ID del color.
  ------------------------------------------------------- */
  function renderPasoBabyVariante() {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '4. Elige el color de botella'));

    var variantes = catalogo.baby_ibero.variantes
      .filter(function (v) { return v.tipo === 'color'; });

    var opciones = el('div', 'vi-opciones');
    variantes.forEach(function (v) {
      var btn = crearBotonOpcion('select-variedad', v.id, state.variedad === v.id);
      if (!v.disponible) {
        btn.disabled = true;
        btn.classList.add('vi-opcion--agotada');
      }
      var imgSlot = el('div', 'vi-opcion__img vi-opcion__img--zoom');
      if (v.imagen) {
        var imgKey = 'img' + v.imagen.split('-').map(function (p) {
          return p.charAt(0).toUpperCase() + p.slice(1);
        }).join('');
        var imgUrl = rootEl.dataset[imgKey];
        if (imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = v.nombre;
          imgSlot.appendChild(img);
        }
      }
      btn.appendChild(imgSlot);
      btn.appendChild(el('span', 'vi-opcion__nombre', v.nombre));
      if (!v.disponible && v.motivo) {
        btn.appendChild(el('span', 'vi-opcion__detalle', v.motivo));
      }
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 4 — Selección de cosecha.
     Ordenada por el campo .orden del catálogo.
  ------------------------------------------------------- */
  function renderPaso4() {
    var cosechas = catalogo.cosechas.slice()
      .sort(function (a, b) { return a.orden - b.orden; });

    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '4. Elige la cosecha'));

    var COSECHA_IMG_KEY = {
      septiembre:      'imgCosechaSeptiembre',
      temprana_octubre: 'imgCosechaOctubre',
      oro_liquido:     'imgCosechaVirgenExtra',
    };

    var opciones = el('div', 'vi-opciones');
    cosechas.forEach(function (cosecha) {
      var btn = crearBotonOpcion('select-cosecha', cosecha.id, state.cosecha === cosecha.id);
      var imgSlot = el('div', 'vi-opcion__img');
      var imgSrc = rootEl.dataset[COSECHA_IMG_KEY[cosecha.id]];
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = cosecha.nombre;
        imgSlot.appendChild(img);
      }
      btn.appendChild(imgSlot);
      btn.appendChild(el('span', 'vi-opcion__nombre', cosecha.nombre));
      btn.appendChild(el('span', 'vi-opcion__detalle', cosecha.descripcion));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 5 — Selección de variedad de aceite.
     Solo se renderiza cuando cosecha === 'temprana_octubre'.
     Muestra las 7 variedades; las no disponibles quedan
     deshabilitadas visualmente y para el click.
  ------------------------------------------------------- */
  function renderPaso5() {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '5. Elige la variedad de aceite'));

    var opciones = el('div', 'vi-opciones');
    catalogo.variedades_aceite.forEach(function (variedad) {
      var btn = crearBotonOpcion('select-variedad', variedad.id, state.variedad === variedad.id);
      if (!variedad.disponible) {
        btn.disabled = true;
        btn.classList.add('vi-opcion--agotada');
      }
      btn.appendChild(el('span', 'vi-opcion__nombre', variedad.nombre));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Paso 6 — Cantidad con precio dinámico.
     Pills de tramo rápido + input numérico libre.

     El precio se actualiza en-place (actualizarPrecio) sin
     llamar a update() en cada tecla, evitando el re-render
     y la pérdida de foco. update() solo se dispara al
     confirmar (blur o Enter), convirtiendo la cantidad en
     state permanente y habilitando el paso siguiente.
  ------------------------------------------------------- */
  function renderPaso6() {
    var tramoClave = getTramoClave();
    var minimo     = getMinimo();
    var tramos     = catalogo.tramos_cantidad[tramoClave]
      .filter(function (t) { return t >= minimo; });

    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '6. Elige la cantidad'));
    paso.appendChild(el('p', 'vi-cantidad__info',
      'Mínimo para este pedido: ' + minimo + ' unidades'));

    /* --- Pills de tramo rápido --- */
    var tramosEl = el('div', 'vi-tramos');
    tramos.forEach(function (t) {
      var btn = document.createElement('button');
      btn.type           = 'button';
      btn.className      = state.cantidad === t
        ? 'vi-tramo vi-tramo--seleccionado' : 'vi-tramo';
      btn.dataset.action = 'select-cantidad';
      btn.dataset.value  = String(t);
      btn.textContent    = t + ' ud.';
      tramosEl.appendChild(btn);
    });
    paso.appendChild(tramosEl);

    /* --- Input numérico libre --- */
    var wrapInput = el('div', 'vi-cantidad-manual');

    var label = document.createElement('label');
    label.htmlFor     = 'vi-input-cantidad';
    label.className   = 'vi-cantidad__etiqueta';
    label.textContent = 'O introduce la cantidad exacta:';

    var input = document.createElement('input');
    input.type        = 'number';
    input.id          = 'vi-input-cantidad';
    input.className   = 'vi-input-numero';
    input.min         = String(minimo);
    input.step        = '1';
    input.placeholder = minimo + '+';
    if (state.cantidad !== null) input.value = String(state.cantidad);

    wrapInput.appendChild(label);
    wrapInput.appendChild(input);
    paso.appendChild(wrapInput);

    /* --- Contenedor de precio (actualizable sin re-render) --- */
    var precioContainer = document.createElement('div');
    paso.appendChild(precioContainer);

    function actualizarPrecio(rawValue) {
      precioContainer.innerHTML = '';
      var n = parseInt(rawValue, 10);
      if (!rawValue || isNaN(n) || n <= 0) return;
      if (n < minimo) {
        precioContainer.appendChild(
          el('p', 'vi-aviso vi-aviso--alerta',
            'El mínimo para este pedido es ' + minimo + ' unidades.')
        );
        return;
      }
      var tramo = getTramoAplicable(n, tramos);
      if (tramo === null) return;
      var precioUnit = getPrecioUnitario(tramo);
      if (precioUnit !== null) {
        precioContainer.appendChild(renderPrecio(precioUnit, n, tramo));
      }
    }

    /* Actualización en vivo (sin commit al state) */
    input.addEventListener('input', function () {
      actualizarPrecio(this.value);
    });

    /* Commit al state + avanzar al siguiente paso */
    function commitSiValido() {
      var n = parseInt(input.value, 10);
      if (!isNaN(n) && n >= minimo) update({ cantidad: n }, true);
    }

    input.addEventListener('change', commitSiValido);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { input.blur(); }
    });

    /* Precio inicial si ya hay cantidad en state */
    if (state.cantidad !== null) actualizarPrecio(String(state.cantidad));

    root.appendChild(paso);
  }

  /* Construye el bloque de desglose de precio.
     Muestra la tarifa de tramo aplicada cuando difiere de cantidadReal. */
  function renderPrecio(precioUnit, cantidadReal, tramo) {
    var total  = precioUnit * cantidadReal;
    var bloque = el('div', 'vi-precio-preview');

    var conceptoUnit = tramo !== cantidadReal
      ? 'Precio/ud. (tarifa ' + tramo + ' ud.)'
      : 'Precio por unidad';

    var filaUnit = el('div', 'vi-precio-preview__fila');
    filaUnit.appendChild(el('span', 'vi-precio-preview__concepto', conceptoUnit));
    filaUnit.appendChild(el('span', 'vi-precio-preview__importe',
      precioUnit.toFixed(2) + ' €'));
    bloque.appendChild(filaUnit);

    var filaTot = el('div', 'vi-precio-preview__fila vi-precio-preview__fila--total');
    filaTot.appendChild(el('span', 'vi-precio-preview__concepto',
      'Total · ' + cantidadReal + ' unidades'));
    filaTot.appendChild(el('span',
      'vi-precio-preview__importe vi-precio-preview__importe--total',
      total.toFixed(2) + ' €'));
    bloque.appendChild(filaTot);

    bloque.appendChild(el('p', 'vi-precio-preview__iva', 'IVA incluido'));
    return bloque;
  }

  /* Wrapper de paso 7 para el slider: usa state.cantidad ya confirmado. */
  function renderPaso7() {
    root.appendChild(renderPaso7Contenido(state.cantidad));
  }

  /* -------------------------------------------------------
     Paso 7 — Extras opcionales.
     Siempre visible tras elegir cantidad; no bloquea avance.
     Librito: precio dinámico (0,40 € × cantidadNum).
     Serigrafía a color: solo si personalización es serigrafía.
     Devuelve el elemento DOM sin añadirlo al root.
  ------------------------------------------------------- */
  function renderPaso7Contenido(cantidadNum) {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '7. Extras opcionales'));

    var extrasEl = el('div', 'vi-extras');

    /* Librito personalizado al cuello */
    var libritoDef   = catalogo.extras.librito_cuello;
    var libritoTotal = (libritoDef.precio * cantidadNum).toFixed(2);
    extrasEl.appendChild(crearExtra(
      'librito_cuello',
      libritoDef.nombre,
      '+' + libritoDef.precio.toFixed(2) + ' € × ' + cantidadNum + ' ud. = ' + libritoTotal + ' €',
      state.extras.indexOf('librito_cuello') !== -1
    ));

    /* Serigrafía a color: solo disponible con personalización serigrafía */
    if (state.personalizacion === 'serigrafia') {
      var seriDef = catalogo.extras.serigrafia_color;
      extrasEl.appendChild(crearExtra(
        'serigrafia_color',
        seriDef.nombre,
        '+' + seriDef.precio.toFixed(2) + ' € fijo al pedido',
        state.extras.indexOf('serigrafia_color') !== -1
      ));
    }

    paso.appendChild(extrasEl);
    return paso;
  }

  /* -------------------------------------------------------
     Paso 8 — Texto personalizado + archivo.
     Ambos campos son opcionales; no bloquean el avance.
     Texto: se confirma al perder el foco (blur).
     Archivo: se confirma al seleccionar (change).
  ------------------------------------------------------- */
  function renderPaso8() {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '8. Texto e imagen'));

    /* --- Textarea: texto personalizado --- */
    var grupoTexto = el('div', 'vi-campo-grupo');
    var labelTexto = document.createElement('label');
    labelTexto.htmlFor     = 'vi-input-texto';
    labelTexto.className   = 'vi-campo__etiqueta';
    labelTexto.textContent = 'Texto personalizado';

    var desc = el('p', 'vi-campo__desc',
      'Escribe los nombres, fecha, mensaje u otro texto que quieras incluir.');
    desc.id = 'vi-desc-texto';

    var textarea = document.createElement('textarea');
    textarea.id          = 'vi-input-texto';
    textarea.className   = 'vi-textarea';
    textarea.rows        = 4;
    textarea.placeholder = 'Ej: María y Carlos · 14 junio 2026';
    textarea.setAttribute('aria-describedby', 'vi-desc-texto');
    if (state.texto_personalizado) textarea.value = state.texto_personalizado;

    textarea.addEventListener('blur', function () {
      update({ texto_personalizado: this.value.trim() });
    });

    grupoTexto.appendChild(labelTexto);
    grupoTexto.appendChild(desc);
    grupoTexto.appendChild(textarea);
    paso.appendChild(grupoTexto);

    /* --- File input: logo o imagen (opcional) --- */
    var grupoArchivo = el('div', 'vi-campo-grupo');
    var labelArchivo = document.createElement('label');
    labelArchivo.htmlFor     = 'vi-input-archivo';
    labelArchivo.className   = 'vi-campo__etiqueta';
    labelArchivo.textContent = 'Archivo (opcional)';

    var descArch = el('p', 'vi-campo__desc',
      'Sube tu logo, diseño o imagen. Formatos admitidos: JPG, PNG, PDF, AI, EPS.');
    descArch.id = 'vi-desc-archivo';

    var fileInput = document.createElement('input');
    fileInput.type    = 'file';
    fileInput.id      = 'vi-input-archivo';
    fileInput.className = 'vi-file-input';
    fileInput.accept  = '.jpg,.jpeg,.png,.pdf,.ai,.eps,.svg';
    fileInput.setAttribute('aria-describedby', 'vi-desc-archivo');

    var fileLabel = document.createElement('label');
    fileLabel.htmlFor   = 'vi-input-archivo';
    fileLabel.className = 'vi-file-label';
    var fileIcono = el('span', 'vi-file-icono', '📎');
    var fileTexto = el('span', 'vi-file-texto',
      state.archivo ? state.archivo.name : 'Seleccionar archivo…');
    fileLabel.appendChild(fileIcono);
    fileLabel.appendChild(fileTexto);

    fileInput.addEventListener('change', function () {
      var f = this.files[0] || null;
      fileTexto.textContent = f ? f.name : 'Seleccionar archivo…';
      fileLabel.classList.toggle('vi-file-label--con-archivo', !!f);
      update({ archivo: f });
    });

    grupoArchivo.appendChild(labelArchivo);
    grupoArchivo.appendChild(descArch);
    grupoArchivo.appendChild(fileInput);
    grupoArchivo.appendChild(fileLabel);
    paso.appendChild(grupoArchivo);

    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Chocolate — Paso A: selección de variedad.
  ------------------------------------------------------- */
  function renderPasoChocolateTipo() {
    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '2. Elige tu chocolate'));

    var opciones = el('div', 'vi-opciones');
    catalogo.chocolate.variedades.forEach(function (v) {
      var btn     = crearBotonOpcion('select-tipo-chocolate', v.id, state.tipo_chocolate === v.id);
      var imgSlot = el('div', 'vi-opcion__img');
      var imgUrl  = rootEl.dataset['imgChoco' + v.id.charAt(0).toUpperCase() + v.id.slice(1)];
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = v.nombre;
        imgSlot.appendChild(img);
      }
      btn.appendChild(imgSlot);
      btn.appendChild(el('span', 'vi-opcion__nombre', v.nombre));
      opciones.appendChild(btn);
    });

    paso.appendChild(opciones);
    root.appendChild(paso);
  }

  /* -------------------------------------------------------
     Chocolate — Paso B: cantidad de tabletas.
     Misma estructura que renderPaso6 (aceite).
  ------------------------------------------------------- */
  function renderPasoCantidadChocolate() {
    var choco  = catalogo.chocolate;
    var minimo = choco.minimo || 10;
    var tramos = Object.keys(choco.precios).map(Number).sort(function (a, b) { return a - b; });

    var paso = el('div', 'vi-paso');
    paso.appendChild(el('h3', 'vi-paso__titulo', '3. ¿Cuántas tabletas necesitas?'));
    paso.appendChild(el('p', 'vi-cantidad__info',
      'Mínimo para este pedido: ' + minimo + ' unidades'));

    /* --- Pills de cantidad rápida --- */
    var tramosEl = el('div', 'vi-tramos');
    tramos.forEach(function (t) {
      var btn = document.createElement('button');
      btn.type           = 'button';
      btn.className      = state.cantidad === t
        ? 'vi-tramo vi-tramo--seleccionado' : 'vi-tramo';
      btn.dataset.action = 'select-cantidad';
      btn.dataset.value  = String(t);
      btn.textContent    = t + ' ud.';
      tramosEl.appendChild(btn);
    });
    paso.appendChild(tramosEl);

    /* --- Input numérico libre --- */
    var wrapInput = el('div', 'vi-cantidad-manual');

    var label = document.createElement('label');
    label.htmlFor     = 'vi-input-cantidad';
    label.className   = 'vi-cantidad__etiqueta';
    label.textContent = 'O introduce la cantidad exacta:';

    var input = document.createElement('input');
    input.type        = 'number';
    input.id          = 'vi-input-cantidad';
    input.className   = 'vi-input-numero';
    input.min         = String(minimo);
    input.step        = '1';
    input.placeholder = minimo + '+';
    if (state.cantidad !== null) input.value = String(state.cantidad);

    wrapInput.appendChild(label);
    wrapInput.appendChild(input);
    paso.appendChild(wrapInput);

    /* --- Contenedor de precio (actualizable sin re-render) --- */
    var precioContainer = document.createElement('div');
    paso.appendChild(precioContainer);

    function actualizarPrecioChoco(rawValue) {
      precioContainer.innerHTML = '';
      var n = parseInt(rawValue, 10);
      if (!rawValue || isNaN(n) || n <= 0) return;
      if (n < minimo) {
        precioContainer.appendChild(
          el('p', 'vi-aviso vi-aviso--alerta',
            'El mínimo para este pedido es ' + minimo + ' unidades.')
        );
        return;
      }
      var tramo = getTramoAplicable(n, tramos);
      if (tramo === null) return;
      precioContainer.appendChild(renderPrecio(choco.precios[String(tramo)], n, tramo));
    }

    input.addEventListener('input',   function () { actualizarPrecioChoco(this.value); });
    input.addEventListener('change',  function () {
      var n = parseInt(input.value, 10);
      if (!isNaN(n) && n >= minimo) update({ cantidad: n }, true);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { input.blur(); } });

    if (state.cantidad !== null) actualizarPrecioChoco(String(state.cantidad));

    root.appendChild(paso);
  }

  /* Calcula totales para el flujo chocolate. */
  function calcularTotalesChocolate() {
    var choco  = catalogo.chocolate;
    var tramos = Object.keys(choco.precios).map(Number).sort(function (a, b) { return a - b; });
    var tramo  = getTramoAplicable(state.cantidad, tramos);
    var precioUnit = tramo !== null ? choco.precios[String(tramo)] : 0;
    return {
      precioUnit: precioUnit,
      tramo:      tramo,
      total:      precioUnit * state.cantidad,
    };
  }

  /* -------------------------------------------------------
     Paso 9 — Resumen completo, desglose de precio y carrito.
  ------------------------------------------------------- */
  function renderPaso9() {
    var resumen = el('div', 'vi-resumen');
    resumen.appendChild(el('h3', 'vi-resumen__titulo', 'Resumen de tu pedido'));

    var imgUrl = getImgUrlActual();
    if (imgUrl) {
      var imgWrap = el('div', 'vi-resumen__img-wrap');
      var imgEl = document.createElement('img');
      imgEl.src = imgUrl;
      imgEl.alt = 'Producto seleccionado';
      imgWrap.appendChild(imgEl);
      resumen.appendChild(imgWrap);
    }

    var tabla = el('dl', 'vi-resumen__tabla');
    function filaResumen(etiqueta, valor) {
      tabla.appendChild(el('dt', 'vi-resumen__etiqueta', etiqueta));
      tabla.appendChild(el('dd', 'vi-resumen__valor', valor));
    }
    var desglose = el('div', 'vi-desglose');
    function filaDesglose(concepto, importe, claseExtra) {
      var fila = el('div', claseExtra ? 'vi-desglose__fila ' + claseExtra : 'vi-desglose__fila');
      fila.appendChild(el('span', 'vi-desglose__concepto', concepto));
      fila.appendChild(el('span', 'vi-desglose__importe', importe));
      desglose.appendChild(fila);
    }

    if (state.tipo === 'chocolate') {
      var chocoVar = catalogo.chocolate.variedades
        .filter(function (v) { return v.id === state.tipo_chocolate; })[0];
      var chocoNombre = chocoVar ? chocoVar.nombre : state.tipo_chocolate;
      filaResumen('Producto', catalogo.chocolate.nombre);
      filaResumen('Variedad', chocoNombre);
      filaResumen('Cantidad', state.cantidad + ' unidades');
      resumen.appendChild(tabla);

      var tot = calcularTotalesChocolate();
      var labelChoco = tot.tramo !== state.cantidad
        ? chocoNombre + ' x ' + state.cantidad + ' ud. (tarifa ' + tot.tramo + ')'
        : chocoNombre + ' x ' + state.cantidad + ' ud.';
      filaDesglose(labelChoco, tot.total.toFixed(2) + ' EUR');
      filaDesglose('Total IVA incluido', tot.total.toFixed(2) + ' EUR', 'vi-desglose__fila--total');

    } else {
      var envaseNombre = catalogo.envases[state.envase].nombre;
      var cosechaObj   = catalogo.cosechas.filter(function (c) { return c.id === state.cosecha; })[0];
      var persNombre   = NOMBRES_PERS[state.personalizacion] || state.personalizacion;

      filaResumen('Tamaño', state.tamaño);
      filaResumen('Envase', envaseNombre);
      filaResumen('Personalización', persNombre);
      filaResumen('Cosecha', cosechaObj ? cosechaObj.nombre : state.cosecha);
      if (state.variedad) {
        var varNombreResumen = state.envase === 'baby_ibero'
          ? (catalogo.baby_ibero.variantes.filter(function (v) { return v.id === state.variedad; })[0] || {}).nombre || state.variedad
          : ((catalogo.variedades_aceite.filter(function (v) { return v.id === state.variedad; })[0] || {}).nombre || state.variedad);
        filaResumen('Variedad', varNombreResumen);
      }
      filaResumen('Cantidad', state.cantidad + ' unidades');
      if (state.extras.length > 0) {
        filaResumen('Extras', state.extras.map(function (id) {
          var def = catalogo.extras[id]; return def ? def.nombre : id;
        }).join(' + '));
      }
      if (state.texto_personalizado) filaResumen('Texto', state.texto_personalizado);
      if (state.archivo)             filaResumen('Archivo', state.archivo.name);
      resumen.appendChild(tabla);

      var totales  = calcularTotales();
      var conceptoAceite = totales.tramo !== state.cantidad
        ? 'Aceite ' + state.tamaño + ' x ' + state.cantidad + ' ud. (tarifa ' + totales.tramo + ')'
        : 'Aceite ' + state.tamaño + ' x ' + state.cantidad + ' ud.';
      filaDesglose(conceptoAceite, totales.subtotalAceite.toFixed(2) + ' EUR');
      if (totales.extraLibrito > 0) {
        filaDesglose(
          catalogo.extras.librito_cuello.nombre + ' x ' + state.cantidad,
          '+ ' + totales.extraLibrito.toFixed(2) + ' EUR'
        );
      }
      if (totales.extraSerigrafia > 0) {
        filaDesglose(
          catalogo.extras.serigrafia_color.nombre,
          '+ ' + totales.extraSerigrafia.toFixed(2) + ' EUR'
        );
      }
      filaDesglose('Total IVA incluido', totales.total.toFixed(2) + ' EUR', 'vi-desglose__fila--total');
    }

    resumen.appendChild(desglose);

    /* --- CTA --- */
    var cta = el('div', 'vi-cta');
    var endpointUrl = rootEl.dataset.endpointUrl;
    if (!endpointUrl) {
      cta.appendChild(el('p', 'vi-aviso vi-aviso--alerta',
        'Configura la URL del endpoint en los ajustes de la sección para habilitar el pedido.'));
    } else {
      var btn = document.createElement('button');
      btn.type              = 'button';
      btn.className         = 'vi-btn-carrito';
      btn.dataset.action    = 'crear-draft';
      btn.textContent       = 'Tramitar pedido';
      cta.appendChild(btn);
    }
    resumen.appendChild(cta);
    root.appendChild(resumen);
  }

  /* -------------------------------------------------------
     POST al endpoint serverless → crea Draft Order en Shopify
     con el precio exacto calculado → redirige a invoice_url.
     Properties con _ son visibles solo en el admin de Shopify.
  ------------------------------------------------------- */
  function crearDraftOrder(btn) {
    var endpointUrl = rootEl.dataset.endpointUrl;
    if (!endpointUrl) return;

    var propiedades = [];
    function addProp(name, value) { propiedades.push({ name: name, value: String(value) }); }
    var titulo, precio;

    if (state.tipo === 'chocolate') {
      var tot      = calcularTotalesChocolate();
      var chocoVar = catalogo.chocolate.variedades
        .filter(function (v) { return v.id === state.tipo_chocolate; })[0];
      var chocoNombre = chocoVar ? chocoVar.nombre : state.tipo_chocolate;
      titulo = catalogo.chocolate.nombre + ' - ' + chocoNombre;
      precio = tot.total.toFixed(2);
      addProp('Producto', catalogo.chocolate.nombre);
      addProp('Variedad', chocoNombre);
      addProp('Cantidad', state.cantidad + ' unidades');
      addProp('_precio_unitario', tot.precioUnit.toFixed(2) + ' EUR/ud.');
      addProp('_total_calculado', tot.total.toFixed(2) + ' EUR');
    } else {
      var totales      = calcularTotales();
      var cosechaObj   = catalogo.cosechas.filter(function (c) { return c.id === state.cosecha; })[0];
      var envaseNombre = catalogo.envases[state.envase].nombre;
      var persNombre   = NOMBRES_PERS[state.personalizacion] || state.personalizacion;
      titulo = envaseNombre + ' ' + state.tamaño + ' - ' + persNombre
             + ' - ' + (cosechaObj ? cosechaObj.nombre : state.cosecha);
      precio = totales.total.toFixed(2);
      addProp('Tamaño',          state.tamaño);
      addProp('Envase',          envaseNombre);
      addProp('Personalizacion', persNombre);
      addProp('Cosecha',         cosechaObj ? cosechaObj.nombre : state.cosecha);
      if (state.variedad) {
        var varNombreProp = state.envase === 'baby_ibero'
          ? (catalogo.baby_ibero.variantes.filter(function (v) { return v.id === state.variedad; })[0] || {}).nombre || state.variedad
          : ((catalogo.variedades_aceite.filter(function (v) { return v.id === state.variedad; })[0] || {}).nombre || state.variedad);
        addProp('Variedad', varNombreProp);
      }
      addProp('Cantidad', state.cantidad + ' unidades');
      if (state.extras.length > 0) {
        addProp('Extras', state.extras.map(function (id) {
          var def = catalogo.extras[id]; return def ? def.nombre : id;
        }).join(', '));
      }
      if (state.texto_personalizado) addProp('Texto personalizado', state.texto_personalizado);
      if (state.archivo) addProp('Archivo adjunto', state.archivo.name + ' (enviar por email)');
      addProp('_precio_unitario', totales.precioUnit.toFixed(2) + ' EUR/ud.');
      addProp('_total_calculado', totales.total.toFixed(2) + ' EUR');
    }

    btn.disabled    = true;
    btn.textContent = 'Procesando…';

    fetch(endpointUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        linea: {
          titulo:      titulo,
          precio:      precio,
          propiedades: propiedades,
        },
      }),
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Error ' + r.status); });
      return r.json();
    })
    .then(function (data) { window.location.href = data.invoice_url; })
    .catch(function (err) {
      btn.disabled    = false;
      btn.textContent = 'Tramitar pedido';
      var cta = btn.closest('.vi-cta');
      var existing = cta.querySelector('.vi-aviso--error');
      if (existing) existing.remove();
      cta.appendChild(el('p', 'vi-aviso vi-aviso--error',
        'No se pudo procesar el pedido: ' + (err.message || 'error desconocido')));
    });
  }

  /* Construye una fila de extra como <label> para que cualquier click
     en la fila active el checkbox nativo, que burbujea al delegado. */
  function crearExtra(id, nombre, precioTexto, activo) {
    var fila      = document.createElement('label');
    fila.className = activo ? 'vi-extra vi-extra--activo' : 'vi-extra';

    var checkbox          = document.createElement('input');
    checkbox.type         = 'checkbox';
    checkbox.className    = 'vi-checkbox';
    checkbox.checked      = activo;
    checkbox.dataset.action = 'toggle-extra';
    checkbox.dataset.value  = id;

    var texto = el('div', 'vi-extra__texto');
    texto.appendChild(el('p', 'vi-extra__nombre', nombre));

    fila.appendChild(checkbox);
    fila.appendChild(texto);
    fila.appendChild(el('span', 'vi-extra__precio', precioTexto));
    return fila;
  }

  /* -------------------------------------------------------
     Listener de clicks delegado en root.
     Cada acción construye sus cambios con limpiarDesde()
     para garantizar que los campos descendientes se resetean.
  ------------------------------------------------------- */
  function handleClick(e) {
    var target = e.target.closest('[data-action]');
    if (!target) return;

    var action = target.dataset.action;
    var value  = target.dataset.value;

    if (action === 'select-tipo') {
      update(Object.assign({ tipo: value }, limpiarDesde('tipo_chocolate')), true);

    } else if (action === 'select-tipo-chocolate') {
      update(Object.assign({ tipo_chocolate: value }, limpiarDesde('cantidad')), true);

    } else if (action === 'select-size') {
      update(Object.assign({ tamaño: value }, limpiarDesde('envase')), true);

    } else if (action === 'select-envase') {
      var cambios = Object.assign({ envase: value }, limpiarDesde('personalizacion'));
      var opcionesPers = catalogo.envases[value].personalizaciones;
      if (opcionesPers.length === 1) cambios.personalizacion = opcionesPers[0];
      update(cambios, true);

    } else if (action === 'select-personalizacion') {
      update(Object.assign({ personalizacion: value }, limpiarDesde('cosecha')), true);

    } else if (action === 'select-cosecha') {
      update(Object.assign({ cosecha: value }, limpiarDesde('variedad')), true);

    } else if (action === 'select-variedad') {
      update(Object.assign({ variedad: value }, limpiarDesde('cantidad')), true);

    } else if (action === 'select-cantidad') {
      update({ cantidad: Number(value) }, true);

    } else if (action === 'toggle-extra') {
      var nuevosExtras = state.extras.slice();
      var idx = nuevosExtras.indexOf(value);
      if (idx === -1) nuevosExtras.push(value);
      else            nuevosExtras.splice(idx, 1);
      update({ extras: nuevosExtras });

    } else if (action === 'crear-draft') {
      crearDraftOrder(target);

    } else if (action === 'nav-atras') {
      var pasos = getPasos();
      var idx = pasos.findIndex(function (p) { return p.id === pasoActual; });
      if (idx > 0) { dirNav = -1; pasoActual = pasos[idx - 1].id; render(); }

    } else if (action === 'nav-adelante') {
      var pasos = getPasos();
      var idx = pasos.findIndex(function (p) { return p.id === pasoActual; });
      if (idx < pasos.length - 1 && pasoCompleto(pasos[idx].id)) {
        dirNav = 1; pasoActual = pasos[idx + 1].id; render();
      }
    }
  }

  /* -------------------------------------------------------
     Inicialización: espera DOM + catálogo resuelto.
  ------------------------------------------------------- */
  /* -------------------------------------------------------
     Panel de resumen parcial — se actualiza en cada render.
     Muestra imagen + selecciones acumuladas del cliente.
  ------------------------------------------------------- */
  function getImgUrlActual() {
    if (state.tipo === 'chocolate') {
      if (state.tipo_chocolate) {
        var chocoVar = catalogo.chocolate.variedades
          .filter(function (v) { return v.id === state.tipo_chocolate; })[0];
        if (chocoVar) {
          var k = 'imgChoco' + state.tipo_chocolate.charAt(0).toUpperCase() + state.tipo_chocolate.slice(1);
          return rootEl.dataset[k] || rootEl.dataset.imgChocolate || '';
        }
      }
      return rootEl.dataset.imgChocolate || '';
    }
    if (state.envase) {
      var persKey = null;
      if (state.personalizacion) {
        var eKey = state.envase.split('_').map(function (s) {
          return s.charAt(0).toUpperCase() + s.slice(1);
        }).join('');
        if (state.envase === 'baby_ibero') {
          if (state.personalizacion === 'color' && state.variedad) {
            var bvImg = catalogo.baby_ibero.variantes.filter(function (v) { return v.id === state.variedad; })[0];
            if (bvImg && bvImg.imagen) {
              persKey = 'img' + bvImg.imagen.split('-').map(function (s) {
                return s.charAt(0).toUpperCase() + s.slice(1);
              }).join('');
            }
          }
          if (!persKey) {
            persKey = 'imgBaby' + state.personalizacion.charAt(0).toUpperCase() + state.personalizacion.slice(1);
          }
        } else {
          persKey = 'imgPers' + eKey + state.personalizacion.charAt(0).toUpperCase() + state.personalizacion.slice(1);
        }
      }
      if (persKey && rootEl.dataset[persKey]) return rootEl.dataset[persKey];
      var envKey = 'imgEnvase' + state.envase.split('_').map(function (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
      }).join('');
      if (rootEl.dataset[envKey]) return rootEl.dataset[envKey];
    }
    return rootEl.dataset['imgAceite'] || '';
  }

  function renderResumenParcial() {
    if (!resumenParcialEl || !state.tipo || pasoActual === 'resumen') {
      if (resumenParcialEl) resumenParcialEl.innerHTML = '';
      return;
    }

    var filas = [];
    function fila(label, valor) { filas.push({ label: label, valor: valor }); }

    if (state.tipo === 'chocolate') {
      fila('Producto', 'Chocolate artesano');
      if (state.tipo_chocolate) {
        var cv = catalogo.chocolate.variedades.filter(function (v) { return v.id === state.tipo_chocolate; })[0];
        fila('Variedad', cv ? cv.nombre : state.tipo_chocolate);
      }
    } else {
      fila('Producto', 'Aceite de oliva virgen extra');
      if (state.tamaño)        fila('Tamaño', state.tamaño);
      if (state.envase)        fila('Envase', catalogo.envases[state.envase].nombre);
      if (state.personalizacion) fila('Personalización', NOMBRES_PERS[state.personalizacion] || state.personalizacion);
      if (state.cosecha) {
        var cos = catalogo.cosechas.filter(function (c) { return c.id === state.cosecha; })[0];
        fila('Cosecha', cos ? cos.nombre : state.cosecha);
      }
      if (state.variedad) {
        var varNombre;
        if (state.envase === 'baby_ibero') {
          var bv = catalogo.baby_ibero.variantes.filter(function (v) { return v.id === state.variedad; })[0];
          varNombre = bv ? bv.nombre : state.variedad;
        } else {
          var vv = catalogo.variedades_aceite.filter(function (v) { return v.id === state.variedad; })[0];
          varNombre = vv ? vv.nombre : state.variedad;
        }
        fila('Variedad', varNombre);
      }
    }
    if (state.cantidad) fila('Cantidad', state.cantidad + ' unidades');

    var imgUrl = getImgUrlActual();

    var html = '<div class="vi-rp">';
    if (imgUrl) {
      html += '<img class="vi-rp__img" src="' + imgUrl + '" alt="Producto seleccionado">';
    }
    html += '<dl class="vi-rp__lista">';
    filas.forEach(function (f) {
      html += '<dt class="vi-rp__etiqueta">' + f.label + '</dt>';
      html += '<dd class="vi-rp__valor">' + f.valor + '</dd>';
    });
    html += '</dl></div>';

    resumenParcialEl.innerHTML = html;
  }

  /* -------------------------------------------------------
     Inicialización: espera DOM + catálogo resuelto.
  ------------------------------------------------------- */
  async function init() {
    rootEl = document.getElementById('vi-configurador-root');
    root   = rootEl;
    if (!rootEl) return;
    resumenParcialEl = document.getElementById('vi-resumen-parcial');

    try {
      catalogo = await window.VI_CATALOGO_PROMISE;
    } catch (_) {
      rootEl.innerHTML =
        '<p class="vi-aviso vi-aviso--error">' +
        'No se pudo cargar el catálogo. Por favor, recarga la página.' +
        '</p>';
      return;
    }

    rootEl.addEventListener('click', handleClick);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
